module.exports = __webpack_public_path__ + "images/6b0ba85ca3422476df3307782b2e65b6.svg";